import { render, staticRenderFns } from "./select-date.vue?vue&type=template&id=90670f5a&"
import script from "./select-date.vue?vue&type=script&lang=js&"
export * from "./select-date.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports